const LanderGame = require('./game');

if (window.location.search.indexOf('nolinks=true') == -1) {
    document.getElementById('links').style.display = 'block';
}

const container = document.getElementById('container');

var game = new LanderGame(
    {
        container: container,
        webroot: ''
    },
    function() {
        container.appendChild(game.renderer.view);
        document.addEventListener('keydown', function(e) {
            if (e.keyCode === 80) {
                if (game.paused) {
                    game.resume();
                } else {
                    game.pause();
                }
            } else if (
                game.paused &&
                (e.keyCode === 38 ||
                    e.keyCode === 37 ||
                    e.keyCode === 39 ||
                    e.keyCode === 32)
            ) {
                game.resume();
            } else if (e.keyCode === 82) {
                game.rocket.reset(true);
            } else if (e.keyCode === 77) {
                if (game.audio_mute) {
                    game.audio_mute = false;
                } else {
                    game.audio_mute = true;
                }
            }
        });
    }
);



//////////////////
// WEBPACK FOOTER
// ./src/app.js
// module id = 88
// module chunks = 0